export default {
  field: {
    label: 'Veroluokka',
    placeholder: 'Ei veroluokkaa',
    unlinked_hint: 'Jos sitä ei ole, tuote käyttää valikkokategoriansa veroluokkaa tai ravintolan vakioverokantaa.',
    default_hint: 'Jos tallennat ilman tätä, se saa valikon oletusveroluokan.',
  },
  empty: {
    hint: 'Ei vielä veroluokkia — lisää yksi alla.',
    read_only_hint: 'Veroluokkia ei ole vielä määritetty.',
  },
  option: {
    varies_by_channel: '(vaihtelee kanavan mukaan)',
  },
  load_error:
    'Veroluokkien lataaminen epäonnistui — linkitys ja linkityksen poisto on poissa käytöstä, kunnes tämä latautuu.',
  create: {
    name_placeholder: 'Uuden luokan nimi',
    rate_placeholder: 'Verokanta %',
    button: 'Lisää veroluokka',
  },
  toasts: {
    create_error: 'Veroluokan luominen epäonnistui.',
  },
};
